import { Spinner } from '@connected/ui/components/spinner';

export function LoadingPage() {
    return (
        <div className="flex justify-center items-center h-screen">
            <Spinner className="w-20 h-20" />
        </div>
    );
}
